// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2oa06","additionalInfo":"AgreementModal_additionalInfo__1OHql"};